import React from 'react';
import FeatureSection from '../components/FeatureSection';
import CompanyValues from '../components/CompanyValues';
// @ts-ignore: module has no declaration file
import useDynamicSEO from '../hooks/dynamicSEO';

const Features: React.FC = () => {

      useDynamicSEO({
    title:"Parking Management Software Features | Smart Automated App",
    description:"Explore features of Park Hive — automated vehicle entry/exit, real-time dashboards, digital payments, revenue transparency & multi-location parking control.",
    keywords:["Parking Management System","Event & Exhibition Parking Management","Parking Lot Management App","Digital Parking Solutions"," Vehicle entry exit management system","AI Parking Management Platform","Parking Lot Automation Software", "Parking revenue management app", "Tourist Attraction Parking Software", "Cinema & Multiplex Parking System"],
    ogTitle:"Parking Management Software Features | Smart Automated App",
    ogDescription:"Explore features of Park Hive — automated vehicle entry/exit, real-time dashboards, digital payments, revenue transparency & multi-location parking control."
    
    })

  return (
    <div className="pt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Powerful Features for Parking Lot & Land Owners
          </h1>
          <p className="text-lg text-gray-600">
            Discover all the features that make ParkHive the perfect solution for maximizing your parking revenue.
          </p>
        </div>
      </div>
      <FeatureSection />
      <CompanyValues />
    </div>
  );
};

export default Features;